import React, { FC, useContext, useEffect, useState } from "react";
import CourseSelectDropdown from "newComponents/Shared/CourseSelectDropdown/CourseSelectDropdown";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import { useRouter } from "next/router";
import { useSelector } from "react-redux";
import { makeSelectActiveLocation } from "Store/locations/selectors";
import colors, { setContrast } from "constants/colors";
import HeaderTab from "newComponents/Shared/_Atoms/HeaderTab/HeaderTab";
import { HeaderContext } from "utils/context/HeaderContext";
import SkeletonLoading from "newComponents/Shared/_Atoms/SkeletonLoading/SkeletonLoading";
import { useBreakpointAction } from "utils/hooks/useBreakpointAction";

interface IProps {
  title: string;
  iconName: IconType;
  back?: boolean;
  headerTabs?: Tab[];
}

const Header: FC<IProps> = ({ title, back, headerTabs, iconName }) => {
  const location = useSelector(makeSelectActiveLocation);
  const [colorScheme, setColorScheme] = useState("light");
  const router = useRouter();
  const { activeTab, disabledTab, handleOnSetActiveTab } = useContext(HeaderContext);
  const tabs = headerTabs?.map((tab) => (
    <HeaderTab
      title={tab.title}
      handleSetActiveTab={handleOnSetActiveTab}
      activeTab={activeTab}
      key={tab.key}
      id={tab.key}
      disabled={tab?.disabled ? tab.disabled : disabledTab}
    />
  ));

  const handleGoBack = async (): Promise<void> => {
    const path = router.pathname.split("/")[1];
    await router.push(`/${path}`);
  };

  useEffect(() => {
    if (location?.branding?.color1) {
      setColorScheme(setContrast(location?.branding?.color1));
    }
  }, [location]);
  return (
    <header
      className={`layout-header ${colorScheme || ""}`}
      style={{
        background: `linear-gradient(90deg, ${location?.branding?.color1} 0%, ${location?.branding?.color2}) 100%`
      }}
    >
      <div className="header-top">
        <div className="header-info">
          {back && (
            <Icon
              icon="arrow-square-left"
              className="header-back-btn"
              onClick={handleGoBack}
              style={{ color: colors[colorScheme === "dark" ? "black" : "white"] }}
            />
          )}
          {Boolean(iconName) && <Icon icon={iconName} className="header-icon" />}
          {title ? <div className="header-title">{title}</div> : <SkeletonLoading lines={2} />}
        </div>
        <CourseSelectDropdown customClass="header-course-selector" />
      </div>
      <div className="header-tab-wrapper">{!!headerTabs?.length && tabs}</div>
    </header>
  );
};

export default Header;
